import {  mergeStatic  } from '../operator/merge';

export const merge = mergeStatic;


// WEBPACK FOOTER //
// ./~/rxjs/src/observable/merge.ts